import { MAX_BENCHMARKING_ITEMS } from '@/constants/scenarios';
import { Colors } from '@/constants/theme';
import { useBenchmarkingStore } from '@/stores/benchmarking-store';
import { Country } from '@/types/country';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ScrollView, StyleSheet, Text } from 'react-native';
import { BenchmarkingItemForm } from './benchmarking-item-form';
import { IconSymbol } from './ui/icon-symbol';
import { Pressable, View } from './ui/tw-wrappers';

export function BenchmarkingSection({ countries }: { countries: Country[] }) {
  const commonProps = useBenchmarkingStore(s => s.commonProps);
  const items = useBenchmarkingStore(s => s.items);
  const { t } = useTranslation();

  const isReportFormDisabled =
    items.length === 0 ||
    items.filter(it => it.customerId !== undefined && it.vendorId !== undefined && it.invoicingConcept !== undefined)
      .length < 2;

  return (
    <View style={styles.container}>
      <ScrollView horizontal showsHorizontalScrollIndicator={false} contentContainerStyle={styles.columnsRow}>
        {items.map((it, idx) => (
          <BenchmarkingItemForm
            key={it.id}
            item={it}
            idx={idx}
            itemsLength={items.length}
            commonProps={commonProps}
            countries={countries}
          />
        ))}
        {/* Add column */}
        {items.length < MAX_BENCHMARKING_ITEMS && (
          <Pressable
            className='w-90'
            style={[styles.colCard, styles.addCol]}
            onPress={() => useBenchmarkingStore.getState().addBenchmarking()}>
            <IconSymbol name='plus' size={32} color={Colors.light.primary} />
            <Text style={{ fontWeight: '700', fontSize: 16, color: Colors.light.primary }}>
              {t('screens.benchmarking.addScenario')}
            </Text>
          </Pressable>
        )}
      </ScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    gap: 14,
    paddingHorizontal: 5,
    width: '100%',
    flex: 1,
  },
  columnsRow: {
    gap: 14,
    paddingRight: 16,
    paddingVertical: 10,
  },
  colCard: {
    height: 466,
    borderRadius: 18,
    padding: 14,
    gap: 4,
  },
  addCol: {
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    borderWidth: 2,
    borderColor: Colors.light.primary,
    borderRadius: 18,
    padding: 14,
    borderStyle: 'dashed',
    backgroundColor: '#f9f9f9',
  },
});
